export default "__VITE_ASSET__DjTwTzim__"